import React, { useState, useEffect } from 'react'
import styles from './settings.module.scss'
import moment from 'moment'
import PageComponent from '../PageComponent'
import Robbot from '../../../icons/robbot.svg'
import UserDetailsChange from './UserDetailsChange'
import PasswordChange from './PasswordChange'
import EmailChange from './EmailChange'
import Card from '../../../icons/card.svg'
import ThirdOptionCard from '../../../icons/thirdOptionCard.svg'
import Calendar from '../../../icons/calendar.svg'
import { useDispatch, useSelector } from 'react-redux'
import {
  closeConfirmationModal,
  setConfirmationModal,
} from '../../../redux/actions/confirmationModal'
import cancelPaymentSubscription from '../../../redux/thunks/account/cancelSubscription'
import CancelSubscription from '../../NestedComponents/Option 1/NestedComponentOfModal/CancelSubscription'
import MiniLogo from '../../../icons/lightMiniLogo.svg'
import LightCheck from '../../../icons/lightCircle.svg'
import { Link } from 'react-router-dom'
import EditPaymentMethod from '../../NestedComponents/Option 2/SettingsModals/EditPaymentMethod'
import isProduction from '../../../utils/helpers/isProduction'

const Settings = () => {
  const dispatch = useDispatch()
  const { userDetails } = useSelector((state) => state)
  // const {
  //   subscriptionDetails: {
  //     nextPaymentDate,
  //     status,
  //     paymentMethodLast4,
  //     chargeAmount,
  //   },
  // } = userDetails
  const nextPaymentDate = userDetails?.subscriptionDetails?.nextPaymentDate
  const status = userDetails?.subscriptionDetails?.status
  const paymentMethodLast4 = userDetails?.subscriptionDetails?.paymentMethodLast4
  const chargeAmount = userDetails?.subscriptionDetails?.chargeAmount
  const [windowWidth, setWindowWidth] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const openCancelModal = () => {
    dispatch(
      setConfirmationModal({
        headerText: 'Abonnement kündigen',
        body: <CancelSubscription />,
        form: {
          comment: '',
          reason: '',
        },
        formErrors: {},
        confirm: {
          text: 'Abonnement kündigen',
          smallPrimaryBg: true,
        },
        cancel: {
          text: 'Abonnement beibehalten',
          smallPrimaryNotBg: true,
        },
        large: true,
        headerBorder: true,
        modalFromSettings: true,

        handleCancel: () => dispatch(closeConfirmationModal()),
        handleConfirm: () => {
          dispatch(cancelPaymentSubscription())
        },
      }),
    )
  }
  const handleEditPaymentMethod = () => {
    dispatch(
      setConfirmationModal({
        headerText: 'Zahlungsmethode aktualisieren',
        body: <EditPaymentMethod />,
        large: true,
        headerBorder: true,
      }),
    )
  }

  const amount = (chargeAmount / 12).toFixed(2).split('.')
  console.log(amount)
  const beforeDecimal = amount[0]
  const afterDecimal = amount[1]
  return (
    <PageComponent>
      {
        <div className={styles.settings}>
          <div>
            {windowWidth.width < 1200 && (
              <div className={styles.robbot}>
                <img src={Robbot} alt={Robbot} />
                <div>
                  {/*<img src={ThirdOptionCard} alt={'ThirdOptionCard'} />*/}
                  <Link
                    to={'https://sorgenloskarte.dev.flexxi.care/'}
                    target="_blank"
                  >
                    Jetzt bewerben
                  </Link>
                </div>
              </div>
            )}
            {
              <div className={styles.container}>
                <h1>Einstellungen</h1>
                <div>
                  <p>Profildetails</p>
                  <div>
                    <UserDetailsChange />
                    <EmailChange />
                    <PasswordChange />
                  </div>
                </div>
                <div>
                  <p>Abonnement</p>
                  {status === 'ACTIVE' ? (
                    <div className={styles.subscription}>
                      <div>
                        <div>
                          <p>Smart</p>
                          <p>Jährliche Abrechnung</p>
                          <p>
                            <img src={Calendar} alt={Calendar} />{' '}
                            <p>
                              Nächste Zahlung: &nbsp;
                              <span>
                                {moment(nextPaymentDate).format('MMM Do, YYYY')}
                              </span>
                            </p>
                          </p>
                          <button onClick={openCancelModal}>
                            Abonnement kündigen
                          </button>
                        </div>
                        {/*<div>*/}
                        {/*  <p>{`€ ${String(chargeAmount / 12).replace('.', ',')} / Monat`}</p>*/}
                        {/*</div>*/}
                        <div>
                          <span>
                            {/*1,<sup>50</sup> EUR&nbsp;*/}
                            {beforeDecimal},<sup>{afterDecimal}&nbsp;</sup>EUR
                          </span>
                          <span>
                            <sup>/Monat</sup>
                          </span>
                        </div>
                      </div>
                      <div>
                        <div>
                          <p>Zahlungsdetails</p>
                          <p>
                            <img src={Card} alt={Card} /> ************
                            {paymentMethodLast4}
                          </p>
                        </div>
                        <div onClick={handleEditPaymentMethod}>
                          Zahlungsmethode ändern
                        </div>
                      </div>
                    </div>
                  ) : (
                    status === 'CANCELLED' && (
                      <div className={styles.column}>
                        <div>
                          <div>
                            <img src={MiniLogo} alt={MiniLogo} />
                            <p>Smart</p>
                          </div>
                          <div className={styles.yearly}>
                            <div>
                              <span>
                                {/*1,<sup>50</sup> EUR&nbsp;*/}
                                {beforeDecimal},<sup>{afterDecimal}</sup> EUR&nbsp;
                              </span>
                              <span>/Monat</span>
                            </div>
                            <div>{`${chargeAmount} EUR / Rechnungstellung für 365 Tage im Voraus`}</div>
                          </div>
                          <span className={styles.included}>Was enthalten ist</span>
                          <div className={styles.CheckLists}>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Zugang zu FLEXX-i Der einfach Nette</p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>
                                Antrag auf Abrechnung der Verhinderungspflege als PDF
                                herunterladen
                              </p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Maximale Nutzung unbegrenzt</p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Persönlicher Zugang zum Dashboard</p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Unbegrenzte Formularerstellung</p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>
                                Vorgespeicherte Daten für eine schnellere
                                Formularerstellung
                              </p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Mehrere Konten für Pflegeempfänger</p>
                            </span>
                            <span>
                              <img src={LightCheck} alt={LightCheck} />
                              <p>Bearbeitbare Formulare</p>
                            </span>
                            {/*<span>*/}
                            {/*  <img src={LightCheck} alt={LightCheck} />*/}
                            {/*  <p>Frühzeitiger Zugang zur FLEXXI Sorgen Los Karte</p>*/}
                            {/*</span>*/}
                          </div>
                        </div>
                        <div className={styles.cardsBtn}>
                          <Link to={'/payment'} state={{ from: '/settings' }}>
                            <button>Mit diesem Plan fortfahren</button>
                          </Link>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            }
            {windowWidth.width > 1200 && (
              <div className={styles.robbot}>
                <img src={Robbot} alt={Robbot} />
                <div>
                  <Link
                    to={
                      isProduction()
                        ? 'https://sorgenloskarte.flexxi.care'
                        : 'https://sorgenloskarte.dev.flexxi.care'
                    }
                    target="_blank"
                  >
                    Jetzt bewerben
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      }
    </PageComponent>
  )
}

export default Settings
